export enum EnumProtocol {
  /** 登录 */
  login = 'login',
  /** 快速注册 */
  register = 'register',
  /** SMB快速注册 */
  smbRegister = 'smg_register',
  /** 政企增值经销商简易注册 */
  relRegister = 'rel_register',
  /** 账号激活 */
  l1InviteRegister = 'l1_invite_register',
  /** 直签代理注册 */
  l2Register = 'l2_register',
}
